import { JobStatus } from "../../enums/jobStatus.enum";
import { NotificationTypes } from "../../enums/notificationTypes";

export const getNotificationType = (status: string) => {
  switch (status) {
    case JobStatus.COMPLETED:
      return NotificationTypes.SUCCESS;
    case JobStatus.FAILED:
      return NotificationTypes.ERROR;
    case JobStatus.PARTIAL_SUCCESS:
      return NotificationTypes.WARNING;
    default:
      return null; 
  }
};
